<template>
  <div class="tes-card pa-7">
    <div v-if="step == 1">
      <div class="form-epd__wrapper">
        <div class="form-epd__col">
          <h1 class="tes-card__title">{{ title }}</h1>
          <p class="mt-5 font-weight-medium mt-4 mb-0"
          :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
            {{$t('client')}}
          </p>
          <p class="mb-0 mt-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
            {{$t('pages.electronicReceipt.infoPart1')}}
          </p>
          <p class="mb-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
            {{$t('pages.electronicReceipt.infoPart2')}}
          </p>
          <loader-wrapper
            :loading="loading"
            :opacity="0.8"
            :showNoDataText="!items.length"
          >
            <v-data-table
              :headers="headers"
              :items="items"
              class="data-table"
              ref="table"
              :hide-default-footer="true"
            >
              <template v-slot:item.subscribe="{ item }">
                <span class="medium-text d-flex justify-center"
                  ><v-checkbox
                    :disabled="true"
                    :input-value="item.subscribe"
                  ></v-checkbox
                ></span>
              </template>

              <template v-slot:item.name="{ item }">
                <span class="roman-text">{{ item.name }}</span>
              </template>
            </v-data-table>
          </loader-wrapper>
        </div>
      </div>
      <div class="form-epd__buttons mt-5">
        <v-btn
          @click="connect"
          :loading="loading"
          :disabled="!items.length"
          class="form-epd__button green-button"
          :class="{'button-font': currentLocale === 'tat'}"
          >{{$t('buttons.connect')}}</v-btn
        >

        <v-btn
          class="form-epd__button red-button"
          :class="{'button-font': currentLocale === 'tat'}"
          :disabled="!items.length"
          :loading="loading"
          @click="shutdown"
          >{{$t('buttons.unconnect')}}</v-btn
        >
      </div>
    </div>
    <div v-if="step == 2 && !successDomhoz.length">
      <div class="form-epd__wrapper">
        <div class="form-epd__col">
          <h1 class="tes-card__title">{{ title }}</h1>
          <p class="mt-5 font-weight-medium mt-4 mb-0"              
          :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
            {{$t('client')}}
          </p>
          <p class="mb-0 mt-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
              {{$t('pages.electronicReceipt.infoConnectPart1')}}
          </p>
          <p class="mb-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
              {{$t('pages.electronicReceipt.infoConnectPart2')}}
          </p>
          <loader-wrapper
            :loading="loading"
            :opacity="0.8"
            :showNoDataText="!items.length"
          >
            <v-data-table
              :headers="headers"
              :items="itemsToConnect"
              class="data-table"
              ref="table"
              :hide-default-footer="true"
            >
              <template v-slot:item.subscribe="{ item }">
                <span class="medium-text d-flex justify-center"
                  ><v-checkbox
                    :disabled="item.subscribeInCurMonth"
                    v-model="item.subscribe"
                  ></v-checkbox
                ></span>
              </template>

              <template v-slot:item.name="{ item }">
                <span class="roman-text">{{ item.name }}</span>
                <span
                  class="roman-text red--text fs-14"
                  v-if="item.subscribeInCurMonth"
                  ><br /><strong
                    >{{$t('pages.electronicReceipt.existApplication').split('_')[0]}}<br />
                    {{$t('pages.electronicReceipt.existApplication').split('_')[1]}}</strong
                  ></span
                >
              </template>
            </v-data-table>
          </loader-wrapper>
          <v-form class="form-epd__fields mt-5" ref="form" lazy-validation>
            <div class="form-epd__field">
              <div class="form-epd__field-label">E-mail:</div>
              <div
                v-show="
                  agreementCheckbox &&
                  !userSettings.email &&
                  !subscription === true
                "
              >
                <v-text-field
                  class="form-epd__field-value"
                  :rules="emailRules2"
                  v-model="inputEmail"
                ></v-text-field>
              </div>
              <div class="form-epd__field-value">
                {{ userSettings.email }}
              </div>

              <div class="form-epd__field-info" v-if="userSettings.email">
                <v-tooltip right max-width="320" nudge-right="10">
                  <template v-slot:activator="{ on }">
                    <v-icon class="info-icon" v-on="on"
                      >mdi-help-circle-outline</v-icon
                    >
                  </template>
                  <span
                    >{{$t('pages.electronicReceipt.mailHint')}}</span
                  >
                </v-tooltip>
              </div>
            </div>
          </v-form>
          <div class="form-epd__subscription">
            <v-checkbox
              class="form-epd__subscriptionCheckbox"
              :label="agreement"
              v-model="agreementCheckbox"
            ></v-checkbox>
          </div>

          <div class="form-epd__buttons mt-10">
            <v-btn
              @click="cancel"
              class="form-epd__button white-button"
              :class="{'button-font': currentLocale === 'tat'}"
              :loading="loading"
              >{{$t('buttons.cancel')}}</v-btn
            >
            <v-btn
              class="form-epd__button blue-button"
              :class="{'button-font': currentLocale === 'tat'}"
              :loading="loading"
              @click="preview"
              :disabled="subscribeButton"
              >{{$t('buttons.view')}}</v-btn
            >
            <v-btn
              class="form-epd__button green-button"
              :class="{'button-font': currentLocale === 'tat'}"
              :loading="loading"
              :disabled="subscribeButton"
              @click="sendForConnect"
              >{{$t('buttons.connect')}}</v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="step == 2 && successDomhoz.length">
      <div class="form-epd__wrapper">
        <div class="form-epd__col">
          <h1 class="tes-card__title">{{ title }}</h1>
          <p class="mt-5 font-weight-medium mt-4 mb-0"
            :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
            {{$t('client')}}
          </p>

          <p class="mb-3 mt-10"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
          {{$t('pages.electronicReceipt.successfulApplication')}}:
          </p>
          <li class="helvetica-roman" v-for="item in successDomhoz" :key="item">
            {{ item }}
          </li>
        </div>
      </div>
    </div>
    <div v-if="step == 3 && !successDomhoz.length">
      <div class="form-epd__wrapper">
        <div class="form-epd__col">
          <h1 class="tes-card__title">{{ title }}</h1>
          <p class="mt-5 font-weight-medium mt-4 mb-0"
              :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
            {{$t('client')}}
          </p>
          <p class="mb-0 mt-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
            {{$t('pages.electronicReceipt.infoUnconnectPart1')}}
          </p>
          <p class="mb-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
            {{$t('pages.electronicReceipt.infoUnconnectPart2')}}
          </p>
          <loader-wrapper
            :loading="loading"
            :opacity="0.8"
            :showNoDataText="!items.length"
          >
            <v-data-table
              :headers="headers"
              :items="itemsToUnconnect"
              class="data-table"
              ref="table"
              :hide-default-footer="true"
            >
              <template v-slot:item.subscribe="{ item }">
                <span class="medium-text d-flex justify-center"
                  ><v-checkbox
                    :disabled="
                      item.subscribeInCurMonth && !item.subscribeDefault
                    "
                    v-model="item.subscribe"
                  ></v-checkbox
                ></span>
              </template>

              <template v-slot:item.name="{ item }">
                <span class="roman-text">{{ item.name }}</span>
                <span
                  class="roman-text red--text fs-14"
                  v-if="item.subscribeInCurMonth && !item.subscribeDefault"
                  ><br /><strong
                    >В этом месяце вы уже производили переключение услуги
                    «Электронный ЕПД» по данному счету. Следующее
                    переключение<br />
                    возможно только в следующем месяце.</strong
                  ></span
                >
              </template>
            </v-data-table>
          </loader-wrapper>
          <v-form class="form-epd__fields mt-5" ref="form" lazy-validation>
            <div class="form-epd__field">
              <div class="form-epd__field-label">E-mail:</div>
              <div class="form-epd__field-value">{{ userSettings.email }}</div>
              <div class="form-epd__field-info" v-if="userSettings.email">
                <v-tooltip right max-width="320" nudge-right="10">
                  <template v-slot:activator="{ on }">
                    <v-icon class="info-icon" v-on="on"
                      >mdi-help-circle-outline</v-icon
                    >
                  </template>
                  <span
                    >{{$t('pages.electronicReceipt.mailHint')}}</span
                  >
                </v-tooltip>
              </div>
            </div>
          </v-form>
          <div class="form-epd__subscription">
            <v-checkbox
              class="form-epd__subscriptionCheckbox"
              :label="disagreement"
              v-model="agreementCheckbox"
            ></v-checkbox>
          </div>

          <div class="form-epd__buttons mt-10">
            <v-btn
              @click="cancel"
              class="form-epd__button white-button"
              :class="{'button-font': currentLocale === 'tat'}"
              :loading="loading"
              >{{$t('buttons.cancel')}}</v-btn
            >
            <v-btn
              class="form-epd__button blue-button"
              :class="{'button-font': currentLocale === 'tat'}"
              :loading="loading"
              @click="previewShutdown"
              :disabled="unSubscribeButton"
              >{{$t('buttons.view')}}</v-btn
            >
            <v-btn
              class="form-epd__button green-button"
              :class="{'button-font': currentLocale === 'tat'}"
              :loading="loading"
              :disabled="unSubscribeButton"
              @click="sendForUnConnect"
              >{{$t('buttons.unconnect')}}</v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="step == 3 && successDomhoz.length">
      <div class="form-epd__wrapper">
        <div class="form-epd__col">
          <h1 class="tes-card__title">{{ title }}</h1>
          <p class="mt-5 font-weight-medium mt-4 mb-0"
              :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
            {{$t('client')}}
          </p>

          <p class="mb-3 mt-10"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
            {{$t('pages.electronicReceipt.successfulUnconApplication')}}:
          </p>
          <li class="helvetica-roman" v-for="item in successDomhoz" :key="item">
            {{ item }}
          </li>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import LoaderWrapper from "../../../components/common/LoaderWrapper";
import { mask } from "vue-the-mask";
import { mapState, mapGetters } from "vuex";

export default {
  name: "index",
  directives: {
    mask,
  },
  layout: "main",
  components: {
    PersonalAccountSelect,
    LoaderWrapper,
  },
  data: () => ({
    inputEmail: "",
    subscription: false,
    agreementCheckbox: false,
    loading: false,
    step: 1,
    items: [],
    itemsToConnect: [],
    itemsToUnconnect: [],
    itemsForResponse: [],
    successDomhoz: [],
  }),
  methods: {
    connect() {
      this.step = 2;

      if(this.userSettings.email){
        this.inputEmail = this.userSettings.email;
      }
    },
    shutdown() {
      this.step = 3;
    },
    cancel() {
      this.agreementCheckbox = false;
      this.step = 1;

      if (this.itemsToConnect.length) {
        this.itemsToConnect.forEach((x) => (x.subscribe = false));
      }

      if (this.itemsToUnconnect.length) {
        this.itemsToUnconnect.forEach((x) => (x.subscribe = true));
      }

      this.successDomhoz = [];
    },
    sendForConnect() {
      if (this.validate()) {
        this.loading = true;
        this.successDomhoz = [];
        if (this.itemsToConnect.length) {
          this.itemsForResponse = this.itemsToConnect.filter(
            (x) => x.subscribe == true && x.subscribeInCurMonth == false
          );

          if (this.itemsForResponse.length) {
            this.itemsForResponse.forEach((item) =>
              this.$store
                .dispatch("statements/toggleElectronicReceipt", {
                  check: true,
                  phone: `${this.userSettings.phone}`,
                  domHoz: item.domHoz,
                  userId: item.guid ? item.guid : this.userSettings.userGuid,
                  email: this.inputEmail
                    ? this.inputEmail
                    : this.userSettings.email,
                  epdDefault: false,
                })
                .then((resp) => {
                  this.loading = false;
                  if (resp.success) {
                    this.successDomhoz.push(item.domHoz);
                  }
                })
                .catch(() => {})
            );
          }
        }
      }
    },
    sendForUnConnect() {
      this.loading = true;
      this.successDomhoz = [];

      if (this.itemsToUnconnect.length) {
        this.itemsForResponse = this.itemsToUnconnect.filter(
          (x) =>
            x.subscribe == false &&
            (x.subscribeInCurMonth == false || x.subscribeDefault)
        );

        if (this.itemsForResponse.length) {
          console.log(this.itemsForResponse);
          this.itemsForResponse.forEach((item) =>
            this.$store
              .dispatch("statements/toggleElectronicReceipt", {
                check: false,
                phone: `${this.userSettings.phone}`,
                domHoz: item.domHoz,
                userId: item.guid ? item.guid : this.userSettings.userGuid,
                email: this.userSettings.email,
                epdDefault: false,
              })
              .then((resp) => {
                this.loading = false;
                if (resp.success) {
                  this.successDomhoz.push(item.domHoz);
                }
              })
              .catch(() => {})
          );
        }
      }
    },

    preview() {
      if (this.itemsToConnect.length) {
        this.itemsForResponse = this.itemsToConnect.filter(
          (x) => x.subscribe == true && x.subscribeInCurMonth == false
        );

        if (this.itemsForResponse.length) {
          this.loading = true;
          this.itemsForResponse.forEach((item) =>
            this.$store
              .dispatch("statements/getElectronicReceiptView", {
                check: true,
                phone: `${this.userSettings.phone}`,
                domHoz: item.domHoz,
                userId: item.guid ? item.guid : this.userSettings.userGuid,
                email: this.inputEmail
                  ? this.inputEmail
                  : this.userSettings.email,
              })
              .then((response) => {
                this.loading = false;
                let key = Math.random() * Math.random() * Math.random();
                localStorage.setItem(key, response);
                let routeData = this.$router.resolve({
                  path: "/preview",
                  query: {
                    title: this.title,
                    key,
                  },
                });

                window.open(routeData.href, "_blank");
              })
              .catch(() => {
                this.loading = false;
              })
          );
        }
      }
    },

    previewShutdown() {
      if (this.itemsToUnconnect.length) {
        this.itemsForResponse = this.itemsToUnconnect.filter(
          (x) =>
            x.subscribe == false &&
            (x.subscribeInCurMonth == false || x.subscribeDefault)
        );

        if (this.itemsForResponse.length) {
          this.loading = true;
          this.itemsForResponse.forEach((item) =>
            this.$store
              .dispatch("statements/getElectronicReceiptView", {
                check: false,
                phone: `${this.userSettings.phone}`,
                domHoz: item.domHoz,
                userId: item.guid ? item.guid : this.userSettings.userGuid,
              })
              .then((response) => {
                this.loading = false;
                let key = Math.random() * Math.random() * Math.random();
                localStorage.setItem(key, response);
                let routeData = this.$router.resolve({
                  path: "/preview",
                  query: {
                    title: this.title,
                    key,
                  },
                });

                window.open(routeData.href, "_blank");
              })
              .catch(() => {
                this.loading = false;
              })
          );
        }
      }
    },
    validate() {
      return !!this.$refs.form.validate();
    },
  },
  computed: {
    ...mapState("account", ["accounts", "selectedAccount", "userSettings"]),
    ...mapGetters("locale",["currentLocale"]),
    title() {
      if (this.step == 1) {
        return this.$t('pages.electronicReceipt.title');
      } else if (this.step == 2) {
        return this.$t('pages.electronicReceipt.applicationConnect');
      } else {
        return this.$t('pages.electronicReceipt.applicationUnconnect');
      }
    },
    subscribeButton() {
      if (
        (!this.userSettings.email && !this.inputEmail) ||
        !this.agreementCheckbox ||
        !this.itemsToConnect.filter((x) => x.subscribe).length
      ) {
        return true;
      } else {
        return false;
      }
    },

    unSubscribeButton() {
      if (
        !this.agreementCheckbox ||
        !this.itemsToUnconnect.filter((x) => !x.subscribe).length
      ) {
        return true;
      } else {
        return false;
      }
    },
    headers() { 
      return [
      {
        text: this.$t('pages.electronicReceipt.epd'),
        value: "subscribe",
        width: "260",
        isSortable: false,
        isFixed: true,
        isResizable: true,
      },
      {
        text: this.$t('personalAccount'),
        value: "name",
        isSortable: false,
        isFixed: true,
        isResizable: true,
      },
    ]
    },
    agreement() {
      return  this.$t('pages.electronicReceipt.agree')
    },
    emailRules2() {
      return [
      (v) => !!v || this.$t('rules.inputEmail'),
      (v) =>
        /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) ||
        this.$t('rules.badSymbols'),
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        this.$t('rules.inputCorrectEmail'),
    ]
    },
    emailHelp() {
      return this.$t('pages.electronicReceipt.emailHelp')
    },
    disagreement() {
      return this.$t('pages.electronicReceipt.agreeUnconnect')
    },
  },
  watch: {
    accounts: {
      immediate: true,
      handler: function (value) {
        this.loading = true;
        this.$store
          .dispatch("statements/checkSubscriptionByPayCode", {
            domHoz: this.selectedAccount.domHoz,
          })
          .then((response) => {
            this.loading = false;
            this.items = response.subscriptions.map((item, domHoz) => ({
              ...item,
              ...this.accounts.find(x => x.domHoz === item.domHoz),
            })).filter((x) => x.isOwner);

            this.itemsToConnect = this.items.filter(
              (x) => !x.subscribe && x.isOwner
            );
            this.itemsToUnconnect = this.items.filter(
              (x) => x.subscribe && x.isOwner
            );
          });
      },
    },
    agreementCheckbox: {
      immediate: true,
      handler: function (value) {
        this.validate();
      },
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.v-data-table .v-data-table-header tr th {
  font-size: 14px !important;
}

.form-epd__buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  position: relative;
  width: 100%;
  margin: 40px 0 0 0;

  @media screen and (max-width: 900px) {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  @media screen and (max-width: 700px) {
    margin: 0px 0 0 0;
  }

  .form-epd__button {
    position: relative;
    margin: 0 28px 0 0;
    min-width: 200px;

    @media screen and (max-width: 900px) {
      width: 33.333%;
      min-width: 80px;
    }

    @media screen and (max-width: 450px) {
      width: 100%;
    }

    &:nth-child(2) {
      @media screen and (max-width: 900px) {
        margin: 0 !important;
      }

      @media screen and (max-width: 450px) {
        margin: 0px 0 0 0 !important;
      }
    }

    &:last-child {
      margin: 0;

      @media screen and (max-width: 900px) {
        margin: 0px 0 0 0 !important;
      }

      @media screen and (max-width: 450px) {
        margin: 0px 0 0 0 !important;
      }
    }
  }
}

.form-epd__fields {
  position: relative;
  width: 100%;
  margin: 40px 0 0 0;

  .form-epd__field {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    width: 100%;
    padding: 60px 0 0 5px;

    @media screen and (max-width: 900px) {
      flex-direction: column;
      align-items: flex-start;
    }

    .form-epd__field-label {
      position: relative;
      width: 100px;
      margin: 0 40px 0 0;

      @media screen and (max-width: 900px) {
        margin: 0;
        width: auto;
      }
    }
    .form-epd__field-value {
      position: relative;
      width: 300px;
      margin: 0 40px 0 0;

      @media screen and (max-width: 900px) {
        margin: 8px 0 8px 0;
      }
    }

    .form-epd__field-info {
      position: relative;
      width: max-content;
    }
  }
}

.info-icon {
  position: relative;
}

.info-icon:hover {
  color: $main-orange;
}
.form-epd__subscription {
  position: relative;
  width: 100%;
  padding: 0 0 0 0;
}
.button-font{
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>
